export default [
  {
    creator: {
      name: 'UiFort',
      tagLine:
        'Check out some examples that our partners from UiFort created using the Reactstrap components library.',
      link: 'https://uifort.com',
    },
    products: [
      {
        title: 'Bamburgh React Admin Dashboard with Reactstrap PRO',
        tagLine: 'Premium React Admin Template',
        imgUrl:
          '/assets/themes/bamburgh-react-admin-dashboard-reactstrap-pro.jpg',
        link:
          'https://uifort.com/template/bamburgh-react-admin-dashboard-reactstrap-pro/?ref=reactstrap.github.io',
      },
    ],
  },
  {
    creator: {
      name: 'Creative Tim',
      tagLine:
        'Check out some examples that our partners from Creative Tim created using the Reactstrap components library.',
      link: 'https://www.creative-tim.com',
    },
    products: [
      {
        title: 'Now UI Kit PRO with Reactstrap',
        tagLine: 'Premium Kit Template for Bootstrap 4 and Reactstrap',
        imgUrl:
          'https://raw.githubusercontent.com/creativetimofficial/public-assets/master/now-ui-kit-pro-react/opt_nukp_react_thumbnail.jpg',
        link: 'https://www.creative-tim.com/product/now-ui-kit-pro-react',
      },
      {
        title: 'Now UI Dashboard PRO with Reactstrap',
        tagLine: 'Premium Reactstrap (Bootstrap 4) Admin Template',
        imgUrl:
          'https://raw.githubusercontent.com/creativetimofficial/public-assets/master/now-ui-dashboard-pro-react/now-ui-dashboard-pro-react.jpg',
        link: 'https://www.creative-tim.com/product/now-ui-dashboard-pro-react',
      },
      {
        title: 'Argon Design System with Reactstrap',
        tagLine: 'Free Design System for Bootstrap 4 and Reactstrap',
        imgUrl:
          'https://raw.githubusercontent.com/creativetimofficial/public-assets/master/argon-design-system-react/argon-design-system-react.jpg',
        link: 'https://www.creative-tim.com/product/argon-design-system-react',
      },
      {
        title: 'Argon Dashboard PRO with Reactstrap',
        tagLine: 'Premium Reactstrap (Bootstrap 4) Admin Template',
        imgUrl:
          'https://raw.githubusercontent.com/creativetimofficial/public-assets/master/argon-dashboard-pro-react/argon-dashboard-pro-react.jpg',
        link: 'https://www.creative-tim.com/product/argon-dashboard-pro-react',
      },
      {
        title: 'Paper Kit PRO with Reactstrap',
        tagLine: 'Premium Kit Template for Bootstrap 4 and Reactstrap',
        imgUrl:
          'https://raw.githubusercontent.com/creativetimofficial/public-assets/master/paper-kit-pro-react/opt_pkp_react_thumbnail.jpg',
        link: 'https://www.creative-tim.com/product/paper-kit-pro-react',
      },
      {
        title: 'Paper Dashboard PRO with Reactstrap',
        tagLine: 'Premium Reactstrap (Bootstrap 4) Admin Template',
        imgUrl:
          'https://raw.githubusercontent.com/creativetimofficial/public-assets/master/paper-dashboard-2-pro-react/opt_pdp_react.jpg',
        link: 'https://www.creative-tim.com/product/paper-dashboard-pro-react',
      },
      {
        title: 'BLK• Design System PRO with Reactstrap',
        tagLine: 'Premium Design System for Bootstrap 4 and Reactstrap',
        imgUrl:
          'https://raw.githubusercontent.com/creativetimofficial/public-assets/master/blk-design-system-pro-react/blk-design-system-pro-react.jpg',
        link:
          'https://www.creative-tim.com/product/blk-design-system-pro-react',
      },
      {
        title: 'Black Dashboard PRO with Reactstrap',
        tagLine: 'Premium Reactstrap (Bootstrap 4) Admin Template',
        imgUrl:
          'https://raw.githubusercontent.com/creativetimofficial/public-assets/master/black-dashboard-pro-react/black-dashboard-pro-react.jpg',
        link: 'https://www.creative-tim.com/product/black-dashboard-pro-react',
      },
    ],
  },
   {
    creator: {
      name: 'WrapPixel',
      tagLine:
        'Check out some examples that our partners from WrapPixel created using the Reactstrap components library.',
      link: 'https://www.wrappixel.com',
    },
    products: [
      {
        title: 'MaterialPro Admin with Reactstrap',
        tagLine: 'Premium Admin Template for Bootstrap 4 and Reactstrap',
        imgUrl:
          'https://www.wrappixel.com/wp-content/uploads/edd/2020/04/materialpro-react-admin-y.jpg',
        link: 'https://www.wrappixel.com/templates/materialpro-react-redux-admin/',
      },
      {
        title: 'Xtreme Admin & Dashboard Template with Reactstrap',
        tagLine: 'Premium Reactstrap (Bootstrap 4) Admin Template',
        imgUrl:
          'https://www.wrappixel.com/wp-content/uploads/edd/2020/04/xtreme-react-admin-template-y.jpg',
        link: 'https://www.wrappixel.com/templates/xtreme-react-redux-admin/',
      },
      {
        title: 'AdminPro React Admin Template with Reactstrap',
        tagLine: 'Best admin templates for Bootstrap 4 and Reactstrap',
        imgUrl:
          'https://www.wrappixel.com/wp-content/uploads/edd/2020/04/adminpro-react-dashboard-y.jpg',
        link: 'https://www.wrappixel.com/templates/adminpro-react-redux-admin/',
      },
      ],
   }, 
  {
    creator: {
      name: 'PIXINVENT',
      tagLine: 'PIXINVENT provides high quality, creative design and easy to use Premium & Free Bootstrap Admin Template',
      link: 'https://1.envato.market/pixinvent_portfolio',
    },
    products: [
      {
        title: 'Vuexy - Vuejs, React, HTML & Laravel Admin Dashboard Template',
        tagLine: 'Best selling, Production Ready, Carefully Crafted Admin Template',
        imgUrl: 'https://www.pixinvent.com/demo/vuexy-html-bootstrap-admin-template/item-page/reactstrap.jpg',
        link: 'https://1.envato.market/vuexy_admin',
      },
    ],
  },
  {
    creator: {
      name: 'MDBootstrap',
      tagLine:
        'Check out some examples that our partners from MDBootstrap created using the Reactstrap components library.',
      link: 'https://mdbootstrap.com/',
    },
    products: [
      {
        title: 'Material Design for Bootstrap 5 & React 17',
        tagLine: '700+ components, stunning templates, 1-min installation, extensive tutorials & huge community.',
        imgUrl:
          'https://mdbcdn.b-cdn.net/wp-content/themes/mdbootstrap4/content/en/_mdb5/react/about/assets/mdb5-react.jpg',
        link: 'https://mdbootstrap.com/docs/b5/react/',
      },
      ],
   }, 
];
